// @flow
import {graphql} from 'react-relay'

import util from 'utils/MiscUtils'
import type {ID} from './types'
import createMutationPromise from './createMutationPromise'

const mutation = graphql`
  mutation UpdateProposalChangeMutation(
    $input: UpdateProposalChangeInput!
  ) {
    updateProposalChange(input: $input) {
      change {
        id
        databaseId

        ...SummarySections_change

        proposal {
          ...TensionEditor_proposal
          ...ChangeList_proposal
          ...EditorFooter_proposal
          ...AcceptButton_proposal
          ...ProposeNowButton_proposal
          ...ProposeMenuItem_proposal
        }
      }
    }
  }
`

export default (changeId: ID, meetingId: ?ID, payload: Object): Promise<mixed> => {
  const variables = {
    input: {
      meetingId,
      changeId,
      ...payload,
    },
  }

  return createMutationPromise({
    mutation,
    variables,
    onCompleted: (response, errors) => {
      if (errors)
        util.warn('there was a problem', errors)
    },
  })
}
